import Cookies from 'js-cookie';

function WebPushNotificationSubscribeHandler() {
    const notificationsParams = (
        document
        .querySelector('body')
        .attributes['data-web-push-notification-parameters']
    );
    let applicationServerParameters = null;
    if (notificationsParams) {
        applicationServerParameters = JSON.parse(notificationsParams.value);
    }

    function urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (
            (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/')
        );

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }

        return outputArray;
    }

    function hasUsers(
        endpoint,
        key,
        token,
    ) {
        const { users } = applicationServerParameters;
        return (
            users
            ? (
                typeof users[endpoint] !== 'undefined'
                && users[endpoint].key === key
                && users[endpoint].token === token
            )
            : false
        );
    }

    function checkUserInCookie(userId) {
        const usersJsonText = Cookies.get('failWpUsers');
        const users = (
            typeof usersJsonText !== 'undefined'
            ? JSON.parse(usersJsonText)
            : {}
        );

        return (
            typeof users[userId] !== 'undefined'
        );
    }

    function saveUnsubscribeCookie(subscriptionId) {
        Cookies.set(
            'unsubscribedWpUser',
            subscriptionId,
            {
                expires: 365,
                path: '/',
            },
        );
    }

    function saveUserCookie(userId) {
        const usersJsonText = Cookies.get('failWpUsers');
        const users = (
            typeof usersJsonText !== 'undefined'
            ? JSON.parse(usersJsonText)
            : {}
        );

        if (typeof users[userId] === 'undefined') {
            users[userId] = {
                c: 1,
                d: Date.now(),
            };
        }
        else {
            users[userId].c += 1;
            users[userId].d = Date.now();
        }

        Cookies.set(
            'failWpUsers',
            JSON.stringify(users),
            {
                expires: 7,
                path: '/',
            },
        );
    }

    function sendSubscriptionToServer(type, subscription) {
        const key = subscription.getKey('p256dh');
        const token = subscription.getKey('auth');

        const { endpoint } = subscription;
        const btoaKey = (
            key
            ? btoa(
                String.fromCharCode.apply(
                    null,
                    new Uint8Array(key),
                ),
            )
            : null
        );
        const btoaToken = (
            token
            ? btoa(
                String.fromCharCode.apply(
                    null,
                    new Uint8Array(token),
                ),
            )
            : null
        );
        let method = (
            type === 'registration'
            ? 'POST'
            : 'PUT'
        );

        if (
            type === 'confirm_unsubscribe'
            || type === 'unsubscribe'
        ) {
            method = 'DELETE';
        }

        if (
            method === 'PUT'
            && hasUsers(endpoint, btoaKey, btoaToken)
        ) {
            return;
        }

        let parametersUrl = '';

        if (type === 'update') {
            parametersUrl += '?confirm_answer=0';
        }
        else if (
            type === 'update_user_id'
            || type === 'unsubscribe'
        ) {
            parametersUrl += '?confirm_answer=1';
        }

        fetch(
            (
                applicationServerParameters.subscriptionPushUrl
                + parametersUrl
            ),
            {
                method,
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                body: JSON.stringify({
                    endpoint,
                    key: btoaKey,
                    token: btoaToken,
                }),
            },
        )
        .then((response) => response.json())
        .then((result) => {
            if (result.method === 'confirm_unsubscribe') {
                if (result.subscribed) {
                    $('#web_push_message_unsubscribe-question')
                    .fadeIn('slow');

                    $('#button-web_push_message_unsubscribe_question_yes')
                    .off('click')
                    .on('click', () => {
                        $('#web_push_message_unsubscribe-question')
                        .fadeOut('slow');

                        sendSubscriptionToServer(
                            'unsubscribe',
                            subscription,
                        );
                    });

                    $('#button-web_push_message_unsubscribe_question_no')
                    .off('click')
                    .on('click', () => {
                        $('#web_push_message_unsubscribe-question')
                        .fadeOut('slow');

                        saveUnsubscribeCookie(
                            result.subscribed,
                        );
                    });
                }
            }
            else if (
                result.method === 'update_subscribe'
                && result.user_id
                && result.other_user
                && !checkUserInCookie(result.user_id)
            ) {
                $('#web_push_message_subscribe-question')
                .fadeIn('slow');

                $('#button-web_push_message_subscribe_question_yes')
                .off('click')
                .on('click', () => {
                    $('#web_push_message_subscribe-question')
                    .fadeOut('slow');

                    sendSubscriptionToServer(
                        'update_user_id',
                        subscription,
                    );
                });

                $('#button-web_push_message_subscribe_question_no')
                .off('click')
                .on('click', () => {
                    $('#web_push_message_subscribe-question')
                    .fadeOut('slow');

                    saveUserCookie(
                        result.user_id,
                    );
                });
            }
        });
    }

    function registerServiceWorker() {
        navigator
        .serviceWorker
        .register(
            applicationServerParameters.serviceWorkerUrl,
        )
        .then(
            (registration) => {
                if (applicationServerParameters.testMessageId) {
                    $.ajax({
                        url: applicationServerParameters.testMessageUrl,
                        data: {
                            'message-id': applicationServerParameters.testMessageId,
                        },
                        success: (response) => {
                            if (response) {
                                registration.showNotification(
                                    response.title,
                                    response.options,
                                );
                            }
                        },
                    });
                }

                registration
                .pushManager
                .getSubscription()
                .then((subscription) => {
                    if (subscription) {
                        $('#web_message_subscribe_push_endpoint')
                        .val(subscription.endpoint);

                        if (applicationServerParameters.unsubscribePopup) {
                            return sendSubscriptionToServer(
                                'confirm_unsubscribe',
                                subscription,
                            );
                        }
                        return sendSubscriptionToServer(
                            'update',
                            subscription,
                        );
                    }

                    registration
                    .pushManager
                    .subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlBase64ToUint8Array(
                            applicationServerParameters.key,
                        ),
                    })
                    .then((newSubscription) => {
                        $('#web_message_subscribe_push_endpoint')
                        .val(newSubscription.endpoint);
                        return sendSubscriptionToServer(
                            'registration',
                            newSubscription,
                        );
                    });

                    return undefined;
                });
            },
            (e) => {
                // eslint-disable-next-line no-console
                console.error('[SW] Service worker registration failed', e);
            },
        );
    }

    function serviceWorkerExists() {
        if (
            !('serviceWorker' in navigator)
            || typeof navigator.serviceWorker === 'undefined'
        ) {
            // eslint-disable-next-line no-console
            console.warn('Service workers are not supported by this browser');
            return false;
        }

        if (
            !('PushManager' in window)
            || typeof window.PushManager === 'undefined'
        ) {
            // eslint-disable-next-line no-console
            console.warn('Push notifications are not supported by this browser');
            return false;
        }

        if (
            !('showNotification' in ServiceWorkerRegistration.prototype)
            || typeof ServiceWorkerRegistration.prototype === 'undefined'
        ) {
            // eslint-disable-next-line no-console
            console.warn('Notifications are not supported by this browser');
            return false;
        }

        // Check the current Notification permission.
        // If its denied, the button should appears as such,
        // until the user changes the permission manually
        if (Notification.permission === 'denied') {
            // eslint-disable-next-line no-console
            console.warn('Notifications are denied by the user');
            return false;
        }

        return true;
    }

    function init() {
        if (!serviceWorkerExists()) {
            return;
        }

        Notification.requestPermission(
            (result) => {
                if (result === 'granted') {
                    try {
                        registerServiceWorker();
                    }
                    catch (e) {
                        // eslint-disable-next-line no-console
                        console.log(e);
                    }
                }
            },
        );
    }

    return {
        init,
    };
}

export default WebPushNotificationSubscribeHandler;
